import { AgreementData1bovrwm0h7gbm as AgreementData } from '../../../utils/AgreementData.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { exportCrowPayLegalDocument31qdjr0k7gqoi as exportCrowPayLegalDocument } from '../../dialogs/emailDocumentDialog.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { html1nvxkcfsy8qu3 as html } from '../../../utils/utils.mjs';
import { handleAuthRendering280086oqucnha as handleAuthRendering } from '../auth/handleAuthRendering.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ViewLegalDocumentClass;
function ViewLegalDocument() {
  if (ViewLegalDocumentClass === VOID) {
    class $ {
      constructor(type) {
        this.rf8_1 = type;
        this.sf8_1 = new (AgreementData())(this.rf8_1);
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        return _this__u8e3s4.lbb(tmp, handleAuthRendering(_this__u8e3s4, VOID, false, ($this$handleAuthRendering, it) => {
          var tmp = sizeConstraints($this$handleAuthRendering, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$handleAuthRendering.pc());
          var tmp0_elvis_lhs = $this$handleAuthRendering.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$handleAuthRendering : tmp0_elvis_lhs;
          $this$handleAuthRendering.gbb(p, view);
          view.zbm(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          view_0.lbb(get_centered(view_0), title(view_0, this.rf8_1.f91_1));
          view_0.lbb(get_centered(view_0), exportCrowPayLegalDocument(view_0, get_waitForNotNull(this.sf8_1.xfy_1)));
          view.hbb(p_0, view_0);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
          html(view_1, ($this$html) => $this$html.eaj(this.sf8_1.xfy_1).b5v_1);
          view.hbb(p_1, view_1);
          $this$handleAuthRendering.hbb(p, view);
          $this$handleAuthRendering.lbb(tmp, view);
          return Unit_instance;
        }));
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ViewLegalDocument', VOID, VOID, [Page()]);
    ViewLegalDocumentClass = $;
  }
  return ViewLegalDocumentClass;
}
//region block: exports
export {
  ViewLegalDocument as ViewLegalDocument2rrxowcqg42d,
};
//endregion

//# sourceMappingURL=ViewLegalDocument.mjs.map
